exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {\n  color: #158482;\n}\n.popup80 .vs-popup {\n  width: 80% !important;\n}\n.popup40 .vs-popup {\n  width: 40% !important;\n}\n", ""]);

// exports
